import { apiClient } from '@/api/client';
import type {
  CostPlanResponse,
  CreateCostPlanRequest,
  PaginatedCostPlans,
  UpdateCostInstallmentRequest,
  UpdateCostPlanRequest,
} from '@/types/shared';

export interface ListCostPlansParams {
  page?: number;
  pageSize?: number;
  beneficiaryType?: 'School' | 'Partner';
  year?: number;
}

/** GET /finance/cost-plans — Roles: Admin, Accounts Officer. */
export async function listCostPlans(params?: ListCostPlansParams): Promise<PaginatedCostPlans> {
  const { data } = await apiClient.get<PaginatedCostPlans>('/finance/cost-plans', { params });
  return data;
}

/** GET /finance/cost-plans/:id */
export async function getCostPlan(id: string): Promise<CostPlanResponse> {
  const { data } = await apiClient.get<CostPlanResponse>(`/finance/cost-plans/${id}`);
  return data;
}

/** POST /finance/cost-plans — Roles: Admin. Total defaults to the configured cost when omitted. */
export async function createCostPlan(payload: CreateCostPlanRequest): Promise<CostPlanResponse> {
  const { data } = await apiClient.post<CostPlanResponse>('/finance/cost-plans', payload);
  return data;
}

/** PATCH /finance/cost-plans/:id — Roles: Admin. */
export async function updateCostPlan(
  id: string,
  payload: UpdateCostPlanRequest,
): Promise<CostPlanResponse> {
  const { data } = await apiClient.patch<CostPlanResponse>(`/finance/cost-plans/${id}`, payload);
  return data;
}

/** PATCH /finance/cost-plans/:id/installments/:no — Roles: Admin, Accounts Officer (records a payment). */
export async function updateCostInstallment(
  id: string,
  installmentNo: number,
  payload: UpdateCostInstallmentRequest,
): Promise<CostPlanResponse> {
  const { data } = await apiClient.patch<CostPlanResponse>(
    `/finance/cost-plans/${id}/installments/${installmentNo}`,
    payload,
  );
  return data;
}
